import { Injectable } from '@angular/core';
import { HubConnection } from '@microsoft/signalr';
import { ScorecardActionMessage } from '../../loyalty/scorecard/models/scorecard-action-message.model';
import { ScorecardCompleteMessage } from '../../loyalty/scorecard/models/scorecard-complete-message.model';
import { ScorecardMilestoneMessage } from '../../loyalty/scorecard/models/scorecard-milestone-message.model';
import { ScorecardService } from '../../loyalty/scorecard/scorecard.service';
import { ISignalRService } from './signalr-service.interface';
import { BadgesService } from '../../loyalty/scorecard/badges/badges.service';
import { ScorecardFacade } from '../../loyalty/scorecard/scorecard-v2/scorecard.facade';

@Injectable({ providedIn: 'root' })
export class SignalRScorecardService implements ISignalRService {
  constructor(
    private scorecardService: ScorecardService,
    private badgesService: BadgesService,
    private scorecardFacade: ScorecardFacade
  ) { }

  /** @inheritdoc */
  registerOnServerEvents(connection: HubConnection): void {
    connection.on('ScorecardActionComplete', (scorecardActionMessage: ScorecardActionMessage) => {
      this.scorecardService.setScorecardActionToCompleted(
        scorecardActionMessage.scorecardId,
        scorecardActionMessage.scorecardActionId
      );
      this.scorecardFacade.setActionCompleted(scorecardActionMessage.scorecardId, scorecardActionMessage.scorecardActionId);
    });

    connection.on('ScorecardMilestoneUpdate', (scorecardMilestoneMessage: ScorecardMilestoneMessage) => {
      this.scorecardService.setScorecardMilesoneCustomerValueUpdate(
        scorecardMilestoneMessage.scorecardId,
        scorecardMilestoneMessage.customerValue
      );
      this.scorecardFacade.setMilestoneCustomerValue(scorecardMilestoneMessage.scorecardId, scorecardMilestoneMessage.customerValue);
    });

    connection.on('ScorecardComplete', (scorecardCompleteMessage: ScorecardCompleteMessage) => {
      this.scorecardService.setScorecardToCompleted(scorecardCompleteMessage.scorecardId, scorecardCompleteMessage.dateCompleted);
      this.scorecardFacade.setScorecardCompleted(scorecardCompleteMessage.scorecardId, scorecardCompleteMessage.dateCompleted);
      this.badgesService.setBadgeToCompleted(scorecardCompleteMessage.scorecardId);
      this.badgesService.setBadgeV2ToCompleted(scorecardCompleteMessage.scorecardId)
    });
  }
}
